import React from "react";
import { TabView, TabPanel } from "primereact/tabview";
import styled from "styled-components";
import "primereact/resources/themes/saga-blue/theme.css";
import "primereact/resources/primereact.min.css";
import "primeicons/primeicons.css";

export interface TabProps {
  tabs: Array<any>;
  currentIndex: number;
  onTabChange: (index: number) => void;
}

const CustomTab = styled(TabView)`
  ul.p-tabview-nav {
    font-weight: 100 !important;
    border: unset !important;
  }
  .p-tabview-nav li {
    width: 24% !important;
    @media (max-width: 768px) {
      width: 50% !important;
    }
  }
  li.p-highlight .p-tabview-nav-link {
    color: #dd052b !important;
    border-color: #dd052b !important;
  }

  li .p-tabview-nav-link {
    padding: 0 !important;
    padding-bottom: 0.5rem !important;
  }
  .p-tabview-panels {
    margin-top: 2.3rem !important;
    padding: 0 !important;
  }

  li .p-tabview-nav-link:not(.p-disabled):focus {
    box-shadow: unset !important;
    -webkit-box-shadow: unset !important;
  }
`;

const Tab: React.FC<TabProps> = ({ tabs, currentIndex, onTabChange }) => (
  <CustomTab
    activeIndex={currentIndex}
    onTabChange={(e) => onTabChange(e.index)}
  >
    {tabs &&
      tabs.map((tab: any, index: number) => {
        return (
          <TabPanel key={index} header={tab.header}>
            {tab.content}
          </TabPanel>
        );
      })}
  </CustomTab>
);

export default Tab;
